import { render } from "./ProfileListInternal.vue?vue&type=template&id=6da268dc&scoped=true"
import script from "./ProfileListInternal.vue?vue&type=script&lang=js"
export * from "./ProfileListInternal.vue?vue&type=script&lang=js"

import "./ProfileListInternal.vue?vue&type=style&index=0&id=6da268dc&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da268dc"]])

export default __exports__